import { z } from 'zod'

import { ChecklistInput } from '@/models'

export const checklistAttachmentRowSchema = z.object({
  id: z.string(),
  type: z.literal('attachment'),
  url: z.string(),
})
export type ChecklistAttachmentRow = z.infer<typeof checklistAttachmentRowSchema>

export const checklistInstructionsRowSchema = z.object({
  html: z.string(),
  id: z.string(),
  type: z.literal('instructions'),
})
export type ChecklistInstructionsRow = z.infer<typeof checklistInstructionsRowSchema>

export const checklistSignaturesRowSchema = z.object({
  checklistId: z.number(),
  id: z.string(),
  signatures: z.array(
    z.object({
      date: z.number(),
      signature: z.string(),
    }),
  ),
  type: z.literal('signatures'),
})
export type ChecklistSignaturesRow = z.infer<typeof checklistSignaturesRowSchema>

export type ChecklistTaskRow =
  | ChecklistAttachmentRow
  | ChecklistInstructionsRow
  | ChecklistSignaturesRow
  | ChecklistInput
